export const data = {
  logo: "/Kundebilleder/imgi_11_Logo-Side-No-BG.png",
  contact: {
    phone: "+45 48 88 89 81",
    email: "daniel.j@guldbosund.dk",
    address: "Vibehaven 500, 4800 Nykøbing F",
    openingHours: "Efter aftale"
  },
  hero: {
    title: "Store dage fortjener rigtige omgivelser",
    subtitle: "Hold jeres næste fest eller konference i Lolland-Falsters mest stemningsfulde rammer ved Guldborgsund.",
    image: "/Kundebilleder/imgi_25_1000001150-scaled.jpg",
    video: "/video/shutterstock_3944111187.mp4",
    cta: "Book Rundvisning"
  },
  services: [
    {
      id: "bryllup",
      title: "Bryllup",
      description: "Den ultimative bryllupspakke hvor intet er overladt til tilfældighederne. Vi sørger for alt fra den røde løber til natmaden.",
      price: "1.295,-",
      image: "/Kundebilleder/d7525ece-6de0-46c0-b5ff-cc6d065f74aa-1_all_6373.jpg",
      features: [
        "Velkomstdrink & snacks ved ankomst",
        "3-retters gourmetmenu sammensat af kokken",
        "Fri bar (øl, vand, husets vine) i 8 timer",
        "Kaffe/te med sødt",
        "Natmad efter eget valg",
        "Egen koordinator under hele forløbet"
      ]
    },
    {
      id: "konfirmation",
      title: "Konfirmation",
      description: "Konfirmation fra 595,- med velkomst, forret, buffet, dessert og flot bordopdækning i valgfrie farver.",
      price: "595,-",
      image: "/Kundebilleder/1000004175.jpg",
      features: [
        "Velkomst",
        "Forret",
        "Buffet",
        "Dessert",
        "Flot bordopdækning i valgfrie farver",
        "Varighed 6 timer med mulighed for at forlænge",
        "Flot stort lyst lokale med udsigt til vand",
        "Vi skræddersyer gerne et tilbud efter jeres ønsker og behov"
      ]
    },
    {
      id: "barnedaab",
      title: "Barnedåb",
      description: "En tryg og rolig start på livet. Vi skaber de perfekte rammer for en intim familiefejring.",
      price: "465,-",
      image: "/Kundebilleder/1000004504.jpg",
      features: [
        "Luksus brunch eller let frokostanretning",
        "Fri kaffe, te og juice",
        "Eget lokale med plads til barnevogne",
        "Puslefaciliteter og hyggehjørne",
        "Hjemmebagt kage til kaffen",
        "Tid til ro og nærvær"
      ]
    }
  ],
  corporate: {
    title: "Konference & Business",
    subtitle: "Professionelle rammer med ro til fordybelse og moderne faciliteter.",
    image: "/Kundebilleder/imgi_19_Auditorum.1-2048x1536.jpg",
    features: [
      "Auditorium med plads til 350 personer",
      "Moderne AV-udstyr & teknisk assistance",
      "Heldagsforplejning fra eget køkken",
      "Gratis parkering og hurtigt Wi-Fi"
    ]
  },
  testimonials: [
    {
      name: "Mette & Thomas",
      text: "Vi holdt vores bryllup her, og det var helt magisk. Maden var i top og omgivelserne er uovertrufne.",
      role: "Brudepar"
    },
    {
      name: "Søren Jensen",
      text: "Fantastisk sted til vores årlige strategiseminar. Roen gav os plads til at tænke kreativt.",
      role: "CEO, Tech Corp"
    }
  ]
};
